import React from 'react';
import { generatePath, useHistory } from 'react-router-dom';

import useAppContext from 'flow/hooks/useAppContext';
import { routes } from 'flow/types/routes';
import BaseButton from 'flow/components/ui-components/BaseButton';
import Icon from 'flow/components/ui-components/Icon';

type Props = {
    conferenceKey: string;
};

const PersonalMeetingRoomButton = ({ conferenceKey }: Props) => {
    const history = useHistory();
    const { i18next } = useAppContext();

    const handleClick = () => {
        history.push(
            generatePath(routes['messages.conferences.entityKey'], {
                entityKey: conferenceKey,
            }),
        );
    };

    return (
        <BaseButton
            onClick={handleClick}
            className="hover:darken-10 h-12 flex-1 justify-between rounded border border-gray-300 bg-white px-4 text-sm text-gray-700"
        >
            <div className="flex items-center gap-2">
                <Icon iconKey="person" className="text-gray-600" />
                {i18next.t('meetings.personal_meeting_room')}
            </div>
            <Icon iconKey="chevron_right" className="text-gray-400" />
        </BaseButton>
    );
};

export default PersonalMeetingRoomButton;
